import { FC } from 'react'

import LowLatencyHosts from '@/components/LowLatencyHosts/LowLatencyHosts'
import { TitleSetter } from '@/components/Title'

export const LowLatencyHostsView: FC = () => {
  return (
    <>
      <TitleSetter title="Low Latency Hosts" />
      <LowLatencyHosts />
    </>
  )
}
